// extracted by mini-css-extract-plugin
export default {"search-with-list":"SearchWithList_search-with-list__wmbiZ","entity-item":"SearchWithList_entity-item__AFMAs"};